import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { ChartBar } from "./chart";
import "../../style.css";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Routes {
  data: {
    occurrences: {
      occurrence_name: string;
      occurrence_code: string;
      qtd: number;
    }[];
  };
}

export const ChartOccurrencesNotDeliveries = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    occurrences: [{ occurrence_name: "", occurrence_code: "", qtd: 0 }],
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/documents/occurrences?graphic_id=chartOccurrencesNotDeliveries&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/documents/occurrences?graphic_id=chartOccurrencesNotDeliveries&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-occurrences-not-deliveries" className="h100">
      <ChartBar data={routes} />
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
